<template>
  <div class="container">
    <van-form @submit="onSubmit">
      <van-nav-bar title="商户资料补全" fixed left-text="" left-arrow @click-left="onClickLeft" />
      <div style="height: 48px"></div>
      <div class="wrapper">
        <div class="wrapper-div">
          <span style="color:#333;font-size: 18px;font-weight: 500">
            请上传您的二代身份证
          </span>

          <div class="upload-div" style="justify-content: space-between">
            <div class="upload-div-item">
              <uploadImage
                :img-src="frontImage"
                submit-field="upFileUrl1"
                :access_token="access_token"
                file-type="1"
                @uploadSuccess="uploadSuccess"
              />
              <span>点击上传身份证人像面</span>
            </div>
            <div class="upload-div-item">
              <uploadImage
                :img-src="backImage"
                submit-field="upFileUrl2"
                type="back"
                :access_token="access_token"
                file-type="1"
                @uploadSuccess="uploadSuccess"
              />
              <span>点击上传身份证国徽面</span>
            </div>
          </div>

          <div class="upload-div">
            <div class="upload-div-item">
              <uploadImage
                :img-src="handImage"
                submit-field="upFileUrl8"
                type="other"
                :access_token="access_token"
                file-type="1"
                @uploadSuccess="uploadSuccess"
              />
              <span>点击上传手持身份证</span>
            </div>
          </div>
        </div>

        <div class="wrapper-div">
          <van-field
            input-align="right"
            error-message-align="right"
            v-model="this.submitParams.name"
            name="手机号码"
            label="姓名"
            maxlength="20"
            placeholder="请输入姓名"
            :rules="[{ required: true, message: '请输入姓名' }]"
          />
          <van-field
            input-align="right"
            error-message-align="right"
            v-model="this.submitParams.idCardNo"
            name="身份证"
            label="身份证"
            maxlength="18"
            placeholder="请输入身份证"
            :rules="[{ required: true, message: '请输入身份证' }]"
          />
          <van-field
            input-align="right"
            error-message-align="right"
            v-model="this.idCardValidityDate"
            name="身份证有效期"
            label="身份证有效期"
            maxlength="18"
            placeholder="请输入身份证有效期"
            :rules="[{ required: true, message: '请输入身份证有效期' }]"
          />
        </div>

        <div class="wrapper-div">
          <span style="color:#333;font-size: 18px;font-weight: 500">
            请上传您的结算卡
          </span>

          <div class="upload-div">
            <div class="upload-div-item">
              <uploadImage
                :img-src="bankImage"
                submit-field="upFileUrl3"
                type="bank"
                :access_token="access_token"
                file-type="1"
                @uploadSuccess="uploadSuccess"
              />
              <span>点击上传结算卡正面</span>
            </div>
          </div>
        </div>

        <div class="wrapper-div">
          <van-field
            input-align="right"
            error-message-align="right"
            v-model="submitParams.stlCardNo"
            name="结算卡卡号"
            label="结算卡卡号"
            placeholder="请输入结算卡卡号"
            :rules="[{ required: true, message: '请输入结算卡卡号' }]"
          />
          <van-field
            input-align="right"
            error-message-align="right"
            v-model="submitParams.phone"
            name="手机号码"
            label="手机号码"
            type="number"
            clearable
            maxlength="11"
            placeholder="请输入手机号码"
            :rules="[{ required: true, message: '请输入手机号码' }]"
          />
        </div>

        <div class="wrapper-div">
          <span style="color:#333;font-size: 18px;font-weight: 500">
            请上传您的经营场所照片
          </span>

          <div class="upload-div" style="justify-content: space-between">
            <div class="upload-div-item">
              <uploadImage
                :img-src="otherImage"
                submit-field="upFileUrl6"
                type="other"
                :access_token="access_token"
                img-class-name="upload-other-img"
                file-type="1"
                @uploadSuccess="uploadSuccess"
              />
              <span>门头照照片</span>
            </div>
            <div class="upload-div-item">
              <uploadImage
                :img-src="otherImage"
                submit-field="upFileUrl4"
                type="other"
                :access_token="access_token"
                img-class-name="upload-other-img"
                file-type="1"
                @uploadSuccess="uploadSuccess"
              />
              <span>经营场所照片</span>
            </div>
          </div>

          <div class="upload-div">
            <div class="upload-div-item">
              <uploadImage
                :img-src="otherImage"
                submit-field="upFileUrl9"
                type="other"
                :access_token="access_token"
                img-class-name="upload-other-img"
                file-type="1"
                @uploadSuccess="uploadSuccess"
              />
              <span>收银台照片</span>
            </div>
          </div>
        </div>
      </div>

      <div style="height: 60px"></div>

      <div class="button-text">
        <van-button round block color="linear-gradient(to right, #FFCE05, #FBC002)" native-type="submit">
          提交
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import { baiduOCR } from '@/assets/js/ocr'
import uploadImage from '@/components/UploadImage.vue'
import frontImage from '@/assets/images/idcard_front.png'
import backImage from '@/assets/images/idcard_back.png'
import handImage from '@/assets/images/handleIdcard.png'
import bankImage from '@/assets/images/bank_front.png'
import otherImage from '@/assets/images/upload_other.png'

export default {
  components: {
    uploadImage
  },
  name: 'MerchantInformation',
  data() {
    return {
      frontImage: frontImage,
      backImage: backImage,
      handImage: handImage,
      bankImage: bankImage,
      otherImage: otherImage,
      access_token: '',
      agtMobile: '',
      fileList: [
        {
          url: '/img/assets/images/idcard_front.png'
        }
      ],
      idCardValidityDate: '',
      submitParams: {
        name: '',
        idCardNo: '',
        idCardNoSecret: '',
        idCardValidityDateStart: '',
        idCardValidityDateEnd: '',
        stlCardNo: '',
        phone: '',
        upFileUrl1: '',
        upFileUrl2: '',
        upFileUrl3: '',
        upFileUrl6: '',
        upFileUrl4: '',
        upFileUrl8: '',
        upFileUrl9: ''
      }
    }
  },
  mounted() {
    this.getBaiduToken()
  },
  methods: {
    onClickLeft() {
      this.$router.back()
    },
    async onSubmit() {
      console.log('submit')
      const { merAccount } = this.$route.query
      // 身份证正面照片未上传
      // 身份证背面照片未上传
      // 手持身份证照片未上传
      // 结算卡正面照未上传
      // 经营场所照未上传
      // 门头照未上传
      // 收银台照未上传

      if (!merAccount) {
        this.$toast('商户ID不存在', { type: 'fail' })
        return
      }

      if (!this.submitParams.upFileUrl1) {
        this.$toast('请上传身份证正面照片', { type: 'fail' })
        return
      }
      if (!this.submitParams.upFileUrl2) {
        this.$toast('请上传身份证背面照片', { type: 'fail' })
        return
      }
      if (!this.submitParams.upFileUrl8) {
        this.$toast('请上传手持身份证照片', { type: 'fail' })
        return
      }
      if (!this.submitParams.upFileUrl3) {
        this.$toast('请上传结算卡正面照片', { type: 'fail' })
        return
      }
      if (!this.submitParams.upFileUrl4) {
        this.$toast('请上传经营场所照片', { type: 'fail' })
        return
      }
      if (!this.submitParams.upFileUrl6) {
        this.$toast('请上传门头照', { type: 'fail' })
        return
      }
      if (!this.submitParams.upFileUrl9) {
        this.$toast('请上传收银台照', { type: 'fail' })
        return
      }
      const res = await this.jsonPostRequest('/api/cold-butler-compose/merAppData/complateH5', { ...this.submitParams, merId: merAccount })
      if (res && res.data.code === 200) {
        this.$toast('提交成功', { type: 'success' })

        this.$router.back()
      }else{
        this.$toast(res.data.msg, { type: 'fail' })
      }
    },
    async getBaiduToken() {
      const params = {
        grant_type: baiduOCR.baiduApi_grant_type,
        client_id: baiduOCR.baiduApi_client_id,
        client_secret: baiduOCR.baiduApi_client_secret
      }
      try {
        const res = await this.postRequest(`/baiduApi/oauth/2.0/token`, params)
        if (res.status === 200) {
          this.access_token = res.data.access_token
        }
        console.log(res)
      } catch (err) {
        console.log(err)
      }
    },
    uploadSuccess({ type, imgBase64, data, field }) {
      this.submitParams[field] = imgBase64
      if (type === 'front') {
        this.submitParams.name = data['姓名'] && data['姓名'].words
        this.submitParams.idCardNo = data['公民身份号码'] && data['公民身份号码'].words
      } else if (type === 'back') {
        this.submitParams.idCardValidityDateStart = data['签发日期'] && data['签发日期'].words
        this.submitParams.idCardValidityDateEnd = data['失效日期'] && data['失效日期'].words
        this.idCardValidityDate = `${this.submitParams.idCardValidityDateStart}-${this.submitParams.idCardValidityDateEnd}`
      } else if (type === 'bank') {
        this.submitParams.stlCardNo = data.bank_card_number ? data.bank_card_number.replace(/\s+/g, '') : ''
      }
    }
  }
}
</script>

<style scoped>
.container {
  width: 100vw;
  height: 100vh;
  overflow: auto;
  background-color: #f5f5f5;
}
.wrapper {
}
.wrapper-div {
  background-color: #fff;
  border-radius: 5px;
  padding: 5px 10px;
  margin: 10px 15px 0;
}
.upload-div {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}
.upload-div-item {
  background-color: #fffbf3;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 110px;
  width: 150px;
}
.upload-img {
  width: 108px;
  height: 68px;
}
.upload-other-img {
  width: 68px;
  height: 68px;
}
.upload-div-item span {
  color: #999999;
  font-size: 10px;
  margin-top: 10px;
}
.button-text {
  height: 60px;
  width: 100%;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  bottom: 0;
}
</style>
